(ns practitest.frontend.common-entities.utils 
  (:require
   [practitest.frontend.components.icons :as icons]))

(defn entity-icon [entity-type]
  (case entity-type
    :test
    ;; TODO: different icon
    [icons/mux-test-library]

    :requirement
    [icons/mux-requirement]

    :issue
    [icons/mux-issue]

    :testset
    [icons/mux-testsets-runs]

    ;; else
    [icons/question-circle]))